import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const DeliveryAddressDropdown = ({ deliveryAddressList = [], personName, sendTransportationChildData }) => {
    const { t } = useTranslation();
    const dropdownRef = useRef(null);
    const [showAddress, setShowAddress] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowAddress(false)
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    
    
    const filteredList = deliveryAddressList.filter(address => {
        const term = searchText.toLowerCase();
        return (
            address.line1?.toLowerCase().includes(term) ||
            address.line2?.toLowerCase().includes(term) ||
            address.line3?.toLowerCase().includes(term) ||
            address.line4?.toLowerCase().includes(term)
        );
    });

    const handleTransportation = (e, value) => {
        e.preventDefault();
        setShowAddress(!showAddress);
        sendTransportationChildData(value);
    };

    return (
        <div ref={dropdownRef} className="w-auto relative">
            <div onClick={() => setShowAddress(!showAddress)}>
                <button className="bg-background-normal justify-between font-normal text-base px-3 py-3 rounded-md inline-flex items-center w-full">
                    <span className={(personName.length > 0 ? "text-black" : "text-gray-dark") + " mr-4 text-xs sm:text-sm text-left"}>
                        {(personName.length > 0)
                            ? <span className="text-xs">{personName}</span>
                            : t('select customer delivery address')}
                    </span>
                    <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                </button>
            </div>
            {showAddress && (
                <ul className="min-h-auto max-h-60 absolute z-10 text-background-dark bg-white shadow-md rounded-md w-full overflow-y-auto no-scrollbar">
                    {/* Search Input */}
                    <div className="py-1.5 px-3">
                        <div className="border border-background-normal cursor-pointer bg-white rounded-lg flex items-center py-2 px-2">
                            <img className="w-4" src="../../../../assets/icons/search.svg" alt="search" />
                            <input
                                className="border-none bg-white focus:outline-none pl-2 w-full placeholder:text-sm"
                                type="text"
                                placeholder={ t("search delivery address")}
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Filtered Transportation List */}
                    {filteredList.length > 0 ? (
                        filteredList.map((address, index) => (
                            <li key={index} onClick={(e) => handleTransportation(e, address)}
                                className="bg-white hover:bg-action-hover cursor-pointer py-1.5 px-3 block whitespace-no-wrap capitalize text-xs sm:text-sm">
                                <div>{address.line1}</div>
                                {(address.line2 || address.line4) && (
                                    <div>
                                        {[address.line2, address.line4].filter(Boolean).join(' | ')}
                                    </div>
                                )}
                            </li>
                        ))
                    ) : (
                        <li className="py-1.5 px-3 text-gray-dark text-xs sm:text-sm first-letter:capitalize">{ t('no results found')}</li>
                    )}
                </ul>
            )}
        </div>
    );
};

export default DeliveryAddressDropdown;
